import { c as _c } from "react/compiler-runtime";
import { NOTA_MAXIMA } from '../../constants/catalogoMomentos';
import type { PesquisaTipo } from '../../types/pesquisaSatisfacaoTypes';
import { tomDaNota, type TomDaNota } from '../../utils/tomDaNota';
import { RostoCsat } from './RostoCsat';
interface SeloNotaProps {
  tipo: PesquisaTipo;
  nota: number;
}
const SELO_POR_TOM: Record<TomDaNota, string> = {
  erro: 'border-error-600 bg-error-100 text-error-700',
  aviso: 'border-warning-600 bg-warning-100 text-warning-700',
  neutro: 'border-neutral-400 bg-neutral-100 text-neutral-600',
  sucesso: 'border-success-600 bg-success-100 text-success-700'
};
export function SeloNota(t0) {
  const $ = _c(7);
  const {
    tipo,
    nota
  } = t0;
  const tom = tomDaNota(tipo, nota);
  const t1 = `Nota ${nota} de ${NOTA_MAXIMA[tipo]}`;
  const t2 = `flex h-11 w-11 flex-none items-center justify-center rounded-[10px] border-2 ${SELO_POR_TOM[tom]}`;
  let t3;
  if ($[0] !== nota || $[1] !== tipo) {
    t3 = tipo === "CSAT" ? <RostoCsat nota={nota} /> : <span className="text-base font-semibold">{nota}</span>;
    $[0] = nota;
    $[1] = tipo;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = <div aria-label={t1} className={t2}>{t3}</div>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}